import {
  evaluateIncidentSubmittability,
  IncidentSubmittability,
} from "../../lib/rules/incidentSubmittability"
import { IncidentModel } from "../incidentsSlice"
import { RootState } from "../store"
import { selectCustomizations } from "./customizations"
import { selectMinistryContext } from "./sharingMinistry"

/**
 * Assembles the input for `evaluateIncidentSubmittability` from the store.
 *
 * The rule itself lives in lib/rules/ and takes explicit arguments so the React
 * Native SDK can call it without a Redux store; this selector is the web/store
 * binding. Returns null when the incident isn't in the store.
 */
export function selectIncidentSubmittability(
  incidentId: string,
): (s: RootState) => IncidentSubmittability | null {
  return (s: RootState) => {
    const incident = s.incidents.incidents.find((i) => i.id === incidentId)
    if (!incident) { return null }
    return evaluateIncidentSubmittabilityFor(s, incident)
  }
}

/**
 * The same rule for callers that already hold the incident, so they don't pay
 * for a second lookup.
 */
export function evaluateIncidentSubmittabilityFor(
  s: RootState,
  incident: IncidentModel,
): IncidentSubmittability {
  return evaluateIncidentSubmittability({
    incident,
    incidentExpenses: s.expenses.expenses.filter((e) => e.incident_id === incident.id),
    incidentSubmissions: s.submissions.submissions.filter((sub) => sub.incident_id === incident.id),
    allMembershipExpenses: s.expenses.expenses,
    allMembershipSubmissions: s.submissions.submissions,
    allMembershipIncidents: s.incidents.incidents,
    attachments: s.attachments.attachments,
  }, {
    hra: selectCustomizations(s).hra,
    ministry: selectMinistryContext(s),
  })
}
